import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Login from "./pages/login";
import Ges_homepage from "./pages/gestionale_home";
import supabase from "../conndb";
import MainPage from "./pages/mainPage";
import Ges_clienti from "./pages/components/componets_gest/ges_clienti";
import "./index.css";
import Ins_interventi from "./pages/components/componets_gest/ins_interventi";
import Stor_interventi from "./pages/components/componets_gest/stor_interventi";
import PreventivoForm from "./pages/components/componets_gest/preventivi";
// ✅ Wrapper per rotta protetta
function ProtectedRoute({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  if (loading) return <p>Caricamento...</p>;
  if (!session) return <Navigate to="/admin" />;

  return children;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainPage />,
  },
  {
    path: "/admin",
    element: <Login />,
  },
  {
    path: "/ges_home",
    element: (
      <ProtectedRoute>
        <Ges_homepage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ges_clienti",
    element: (
      <ProtectedRoute>
        <Ges_clienti />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ins_interventi",
    element: (
      <ProtectedRoute>
        <Ins_interventi />
      </ProtectedRoute>
    ),
  },
    {
    path: "/stor_interventi",
    element: (
      <ProtectedRoute>
        <Stor_interventi/>
      </ProtectedRoute>
    ),
  },
  {
    path: "/preventivi",
    element: (
      <ProtectedRoute>
        <PreventivoForm/>
      </ProtectedRoute>
    ),
  },
]);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
